import { apiFetch } from '@/lib/api'
import { encryptPassword } from '@/lib/crypto'

export interface LoginRequest {
  account: string
  password: string  // AES encrypted
}

export interface LoginResponse {
  token: string
  userId: number
  name: string
}

export interface RegisterAdminRequest {
  account: string
  name: string
  password: string  // raw password, backend will AES+SHA256
}

// POST /api/auth/login
export const login = (account: string, rawPassword: string) => {
  const password = encryptPassword(rawPassword)
  return apiFetch<{ success: boolean; message: string; data: LoginResponse }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ account, password })
  })
}

// POST /api/auth/register-admin
export const registerAdmin = (payload: RegisterAdminRequest) =>
  apiFetch<{ success: boolean; message: string; data: number }>('/api/auth/register-admin', {
    method: 'POST',
    body: JSON.stringify(payload)
  })
